import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CurrencyPipe } from '@angular/common';
import { BalanceService } from '@services/balance.service';
import { ConfigurationService } from '@services/configuration.service';
import { TokenService } from '@services/token.service';

@Component({
  selector: 'app-sidebar-recharge-method',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatSidenav,
    MatIconModule,
    MatButtonModule,
    CurrencyPipe,
  ],
  templateUrl: './sidebar-recharge-method.component.html',
  styleUrl: './sidebar-recharge-method.component.css'
})
export class SidebarRechargeMethodComponent {
  @ViewChild(MatSidenav) sidenav!: MatSidenav;
  @Output() cardSelected: EventEmitter<void> = new EventEmitter<void>();
  @Output() transferSelected: EventEmitter<void> = new EventEmitter<void>();

  balance: number = -1;
  plusPagosCommission: number = 0;
  benkoCommission: number = 0;

  constructor(
    private balanceService: BalanceService,
    private configService: ConfigurationService,
    private tokenService: TokenService,
  ) {}

  ngOnInit() {
    this.watchForBalanceUpdates();
    this.watchAuthStatus();
    this.getValuesOfConfiguration();
  }

  open() {
    this.sidenav.open();
  }

  close() {
    this.sidenav.close();
  }

  selectCard() {
    this.sidenav.close();
    this.cardSelected.emit();
  }

  selectTransfer() {
    this.sidenav.close();
    this.transferSelected.emit();
  }

  watchForBalanceUpdates() {
    this.balanceService.watchBalanceUpdates().subscribe({
      next: (balance) => {
        this.balance = balance.balance + balance.bonusBalance;
      }
    });
  }

  getValuesOfConfiguration() {
    if (!this.tokenService.isAuthenticated.value) {
      return;
    }
    this.configService.getConfiguration().subscribe({
      next: (response) => {
        this.plusPagosCommission = parseFloat(response.find((r) => r.key == 'plusPagosCommission')?.value || '0');
        this.benkoCommission = parseFloat(response.find((r) => r.key == 'benkoCommission')?.value || '0');
      },
    });
  }

  watchAuthStatus() {
    this.tokenService.isAuthenticated.subscribe({
      next: () => {
        this.getValuesOfConfiguration();
      }
    });
  }
}
